import { useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
import { useAtomValue } from "jotai";
import {
  hasTourableNodesAtom,
  isTourOrExplanationRunningAtom,
} from "@zapier/canvas-state";

export function useStartTourFromQueryParams() {
  const searchParams = useSearchParams();
  const tourSearchParam = searchParams?.get("tour");
  const shouldStartTour = tourSearchParam === "true";
  const hasStartedTour = useRef(false);
  const hasTourableNodes = useAtomValue(hasTourableNodesAtom);
  const isTourOrExplanationRunning = useAtomValue(
    isTourOrExplanationRunningAtom,
  );

  useEffect(() => {
    if (
      shouldStartTour &&
      !hasStartedTour.current &&
      hasTourableNodes &&
      !isTourOrExplanationRunning
    ) {
      hasStartedTour.current = true;

      // Auto-start tour location #1: From query params (when navigating from AI/template pages)
      // Note: There are 2 places where tour can auto-start - this is one, and executeZslAndSaveSetter is the other
      // Copilot has the buttons that suggest to start the tour, so we don't auto-start
    }
  }, [shouldStartTour, hasTourableNodes, isTourOrExplanationRunning]);
}
